const isUTCDateString = (datestring: string): boolean => {
  const validationRegex = /\d{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2]\d|3[0-1])T(?:[0-1]\d|2[0-3]):[0-5]\d:[0-5]\dZ/;

  return validationRegex.test(datestring);
};

export default isUTCDateString;
